import { listPlans } from "@/lib/db/queries/plans";
import { logActivity } from "@/lib/db/audit";
import { getSession } from "@/lib/auth/session";
import { PlansGrid } from "./_components/plans-grid";

export const dynamic = "force-dynamic";

export default async function PlansPage() {
  const session = await getSession();
  let rows: Awaited<ReturnType<typeof listPlans>> = [];
  let loadError: string | null = null;
  try {
    rows = await listPlans();
    void logActivity({
      type: "superadmin.plans_list",
      title: "Lecture du référentiel plans",
      description: `${rows.length} plans lus`,
      user_id: session?.user.id,
    });
  } catch (err) {
    loadError = err instanceof Error ? err.message : "Erreur inconnue";
  }

  return (
    <div className="px-6 py-6 lg:px-10">
      <header className="mb-6">
        <h1 className="text-2xl font-semibold">Plans</h1>
        <p className="text-sm text-muted-foreground">
          Tiers d&apos;abonnement (starter, pro, enterprise) et quotas associés.
          Cliquez sur « Modifier » pour ajuster les prix, les limites ou les
          fonctionnalités incluses.
        </p>
      </header>

      {loadError && (
        <div className="rounded-md border border-red-200 bg-danger-subtle px-4 py-3 text-sm text-danger">
          Impossible de charger les plans : {loadError}
        </div>
      )}

      {!loadError && rows.length === 0 && (
        <div className="rounded-md border border-border bg-surface px-4 py-8 text-center text-sm text-muted-foreground">
          Aucun plan configuré.
        </div>
      )}

      {!loadError && rows.length > 0 && <PlansGrid rows={rows} />}
    </div>
  );
}
